import type { RouteObject } from "react-router";
import { PortalFrame } from "./components/PortalFrame.js";
import { PORTAL_PATHS } from "./paths.js";
import type { RuntimeConfig } from "./runtime-config.js";
import { HomeScreen } from "./screens/HomeScreen.js";
import { NotFoundScreen } from "./screens/NotFoundScreen.js";

/**
 * The portal's route table (NEX2-232), built from the validated runtime configuration as
 * Checkout's is, so the frame always has the origins it reports and links to (`FE-06`/`FE-07`).
 * Every screen renders inside the Nexus frame; route `id`s are stable names a test can match on,
 * and the catch-all keeps an unknown path inside the frame instead of the router's default error.
 */
export function createPortalRoutes(config: RuntimeConfig): RouteObject[] {
  return [
    {
      element: <PortalFrame config={config} />,
      id: "frame",
      path: PORTAL_PATHS.home,
      children: [
        { element: <HomeScreen />, id: "home", index: true },
        { element: <NotFoundScreen />, id: "not-found", path: "*" },
      ],
    },
  ];
}
